
import Vue from "vue";
import Component from "vue-class-component";
import Listas from "@/models/lists/listas.model"
import {ContratoFilter} from "@/models/contratos/contrato-filter.interface";
import ContratoModel from "@/models/contratos/contrato.model";
import ContratoService from "@/service/contrato.service";
import FormatUtil from "@/util/format.util";
import {namespace} from "vuex-class";
import {MapActionsLoading} from "@/store/modules/loading/map-actions.loading";
import DescricaoID from "@/models/lists/descricao-id.model";

const loading = namespace('loading');

@Component({
  name: "ContratoInicio",
  components: {}
})
export default class ContratoInicio extends Vue {

  @loading.Action(MapActionsLoading.OPEN_LOADING) openLoading;
  @loading.Action(MapActionsLoading.CLOSE_LOADING) closeLoading;

  private format = FormatUtil;
  private listaContratos: Array<ContratoModel> = [];
  private listas = new Listas();
  private filtro = {} as ContratoFilter;
  private openDelete = false;
  private idSelecionado: number | null = null;

  async pesquisar() {
    this.openLoading();
    this.listaContratos = await ContratoService.buscarComFiltro(this.filtro);
    this.closeLoading();
  }

  async deletar() {
    await ContratoService.delete(this.idSelecionado);
    this.openDelete = false;
    await this.getAll();
  }

  limpar() {
    this.filtro = {} as ContratoFilter;
  }

  async getAll() {
    this.openLoading();
    this.listaContratos = await ContratoService.buscarComFiltro(undefined);
    this.closeLoading();
  }

  goContato(item: ContratoModel) {
    this.$router.push(`contratos/${item.id}/`);
  }

  goEdit(item: ContratoModel) {
    this.$router.push(`contratos/${item.id}`);
  }

  goDelete(item: ContratoModel) {
    this.idSelecionado = item.id;
    this.openDelete = true;
  }

  async mounted() {
    this.getAll();
  }
}
